// import MetaPixelScript from './meta-pixel'
// import BingScript from './bing'
import AppsFlyerScript from './apps-flyer'
// import Ga4Script from './google-tag-manager'
// import SegmentScript from './segment'
import GTMScript from './gtmScript'
import NewrelicBrowserAgentScript from './newrelic-browser-agent'
import useIsInApp from '@/hooks/use-is-in-app'

export default function GlobalExternalScripts({ isGtmDisabled }) {
  const isApp = useIsInApp()
  if (isApp) return null
  return (
    <>
      {/* <SegmentScript /> */}
      {/* <BingScript /> */}
      {/* ga4 */}
      {!isGtmDisabled && <GTMScript />}
      {/* <Ga4Script /> */}
      {/* <MetaPixelScript /> */}
      <AppsFlyerScript />
      <NewrelicBrowserAgentScript />
    </>
  )
}
